export var BankingFeatures;
(function (BankingFeatures) {
    BankingFeatures["ApplePay"] = "APPLE_PAY";
    BankingFeatures["BranchAccess"] = "BRANCH_ACCESS";
    BankingFeatures["CreditCard"] = "CREDIT_CARD";
    BankingFeatures["FeeFreeAtmTransactions"] = "FEE_FREE_ATM_TRANSACTIONS";
    BankingFeatures["GooglePay"] = "GOOGLE_PAY";
    BankingFeatures["InternetBanking"] = "INTERNET_BANKING";
    BankingFeatures["MobileApp"] = "MOBILE_APP";
    BankingFeatures["OpenToEverything"] = "OPEN_TO_EVERYTHING";
    BankingFeatures["SamsungPay"] = "SAMSUNG_PAY";
    BankingFeatures["UrgentTurnaround"] = "URGENT_TURNAROUND";
})(BankingFeatures || (BankingFeatures = {}));
//# sourceMappingURL=BankingFeatures.js.map